// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-header----HeaderBar-module---container---B9UmD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/HeaderBar.module.css
// module id = 644
// module chunks = 168707334958949